export default __webpack_public_path__ + "static/streamlining-data-salesforce-6aa73dee1ea55f23d5c81baf3f898779.png";